/* eslint-disable no-console */
import axios from 'axios';

import buildInstitutionURL from './buildInstitutionURL';

const apiClient = axios.create({
  baseURL: buildInstitutionURL({ subdomain: 'apiv2' }),
});

let blockRequests = false;

apiClient.interceptors.request.use(
  (config) => {
    if (blockRequests) {
      console.warn('API call blocked:', config.url);
      // Return a mock response to avoid breaking awaiting calls
      return Promise.reject(new Error(`API call blocked:, ${config.url}`));
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const setAPIBlock = (shouldBlock) => {
  blockRequests = shouldBlock;
  console.log(`API Blocking is now ${shouldBlock ? 'ENABLED' : 'DISABLED'}`);
};

export default apiClient;
